module.exports = __webpack_public_path__ + "img/yunnanzhutong.8c3a9b24.jpg";